export enum DisciplineEnum {
  MECHANICAL = 'mechanical',
  ELECTRICAL = 'electrical',
  PLUMBING = 'plumbing',
  INSTRUMENTATION = 'instrumentation',
}
